module.exports = __webpack_public_path__ + "static/img/itemDetail.ea25d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linshi/itemDetail.png
// module id = 8oVV
// module chunks = 44